import { Device, DeviceV2, RawDeviceV2 } from "@/entities";
import { BACKEND_BASE_URL, BACKEND_BASE_URL_READS, ResponseCreateV2 } from "../backend.types";
import { DeviceService } from "@/services";
import Vue from "vue";
import { DeviceAlert } from "@/entities/deviceAlert/deviceAlert";
import { RawDeviceAlert } from "@/entities/deviceAlert/deviceAlert.types";

export class DeviceServiceImpl implements DeviceService {
  async fetchDeviceById(deviceId: string): Promise<DeviceV2> {
    const { data } = await Vue.$axios.get<RawDeviceV2>(`${BACKEND_BASE_URL_READS}/api/v1/device/${deviceId}`);
    return new DeviceV2(data);
  }

  async fetchDeviceAlerts(deviceId: string): Promise<DeviceAlert[]> {
    const { data } = await Vue.$axios.get<RawDeviceAlert[]>(
      `${BACKEND_BASE_URL_READS}/api/v1/device/${deviceId}/alerts`
    );
    return data.map((rawDeviceAlert) => new DeviceAlert(rawDeviceAlert));
  }

  async createDeviceV2(device: DeviceV2): Promise<ResponseCreateV2> {
    const { data } = await Vue.$axios.post<ResponseCreateV2>(`${BACKEND_BASE_URL}/api/v2/device`, {
      countryCode: device.countryCode,
      code: device.code,
      clientMode: device.clientMode,
      name: device.name,
      type: device.type,
      manufacturer: device.manufacturer,
      model: device.model,
      currencies: device.currencies,
      manufacturerCoinCapacity: device.manufacturerCoinCapacity,
      realCoinCapacity: device.realCoinCapacity,
      prosegurCoinCapacity: device.prosegurCoinCapacity,
      manufacturerNoteCapacity: device.manufacturerNoteCapacity,
      realNoteCapacity: device.realNoteCapacity,
      prosegurNoteCapacity: device.prosegurNoteCapacity,
      deviceAlerts: device.deviceAlerts,
    });
    return data;
  }

  async updateDeviceV2(device: DeviceV2): Promise<void> {
    const { data } = await Vue.$axios.put<any>(`${BACKEND_BASE_URL}/api/v2/devices/${device.id}`, {
      name: device.name,
      manufacturer: device.manufacturer,
      model: device.model,
      currencies: device.currencies,
      manufacturerNoteCapacity: device.manufacturerNoteCapacity || 0,
      realNoteCapacity: device.realNoteCapacity || 0,
      prosegurNoteCapacity: device.prosegurNoteCapacity || 0,
      manufacturerCoinCapacity: device.manufacturerCoinCapacity || 0,
      realCoinCapacity: device.realCoinCapacity || 0,
      prosegurCoinCapacity: device.prosegurCoinCapacity || 0,
      deviceAlerts: device.deviceAlerts,
    });
  }

  async changeStatus(device: Device): Promise<void> {
    console.log("changeStatus " + JSON.stringify(device));
  }
}
